export default "__VITE_ASSET__NZFXKVyM__"